/**
 * Saneado y filtrado de texto. El cliente siempre muestra texto con textContent (nunca innerHTML),
 * así que aquí se trata de normalizar, eliminar caracteres de control y censurar palabras.
 */

const DEFAULT_BLOCKLIST = [
  'puta',
  'puto',
  'mierda',
  'gilipollas',
  'cabron',
  'cabrón',
  'maricon',
  'maricón',
  'zorra',
  'subnormal',
  'retrasado',
  'polla',
  'coño',
  'joder',
  'fuck',
  'shit',
  'bitch',
  'nigger',
  'faggot',
  'retard',
  'nazi',
];

// Caracteres de control, de formato bidireccional y de anchura cero
const CONTROL_RE = /[\u0000-\u001f\u007f-\u009f\u200b-\u200f\u202a-\u202e\u2060-\u206f\ufeff]/g;

export function sanitizeText(input: string, maxLength: number): string {
  return input.normalize('NFKC').replace(CONTROL_RE, '').replace(/\s+/g, ' ').trim().slice(0, maxLength);
}

const fold = (s: string) =>
  s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[0@]/g, 'o')
    .replace(/[1!|]/g, 'i')
    .replace(/3/g, 'e')
    .replace(/4/g, 'a')
    .replace(/[5$]/g, 's');

export class ProfanityFilter {
  private words: string[];

  constructor(extra: string[] = [], replaceDefaults = false) {
    const base = replaceDefaults ? [] : DEFAULT_BLOCKLIST;
    this.words = [...new Set([...base, ...extra].map((w) => fold(w.trim())).filter(Boolean))];
  }

  /** Sustituye por asteriscos las palabras bloqueadas (por palabra completa tras normalizar). */
  clean(text: string): { text: string; flagged: boolean } {
    let flagged = false;
    const out = text.replace(/[\p{L}\p{N}@$!|]+/gu, (word) => {
      const f = fold(word);
      if (this.words.some((w) => f === w || (w.length >= 5 && f.includes(w)))) {
        flagged = true;
        return '*'.repeat(Math.min(word.length, 8));
      }
      return word;
    });
    return { text: out, flagged };
  }

  isClean(text: string): boolean {
    return !this.clean(text).flagged;
  }
}

/** Nombres: letras, números, espacios, guion y guion bajo. */
export const NAME_RE = /^[\p{L}\p{N} _-]+$/u;
